import useSWRImmutable from "swr/immutable"

import { AppError } from "../../../../../errors/errorProcessors"
import { invalidApiDataError } from "../../../../../errors/recognisedErrors"
import { getClientProtected } from "../../../clients/clients"
import { startNewVersionMapper } from "../../../mappers/registerDevice/startNewVersionMapper"
import { NEW_VERSION_CONFIG } from "../../../swrConfig"
import { TNewVersionResponse } from "../../../types/devices/ttr/publishDeviceTypes"
import { START_NEW_VERSION } from "../../../urls/private"

interface IUseStartNewVersionOutput {
    data?: TNewVersionResponse
    isLoading: boolean
    isValidating: boolean
    error?: AppError
}

/**
 * Hook for starting a new device version.
 * Returns data for the new device version, which is then used to populate the device context
 */
const useStartNewVersion = (deviceRef: string): IUseStartNewVersionOutput => {
    const { data, error, isLoading, isValidating } = useSWRImmutable(
        START_NEW_VERSION(deviceRef),
        async (url: string): Promise<TNewVersionResponse> => {
            try {
                const response = await getClientProtected(url)
                return startNewVersionMapper.map(response)
            } catch {
                throw invalidApiDataError("Failed to start new version")
            }
        },
        NEW_VERSION_CONFIG
    )

    return {
        data,
        isLoading,
        isValidating,
        error,
    }
}

export default useStartNewVersion
